import { render } from "./GestionCategorias.vue?vue&type=template&id=0adc37d6&scoped=true"
import script from "./GestionCategorias.vue?vue&type=script&lang=js"
export * from "./GestionCategorias.vue?vue&type=script&lang=js"

import "./GestionCategorias.vue?vue&type=style&index=0&id=0adc37d6&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0adc37d6"]])

export default __exports__